// extracted by mini-css-extract-plugin
export default {"formList":"index_formList_tfLKK","formHorizontal":"index_formHorizontal_m7f3t"};